import firebase from 'firebase'


  const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyAtsaH-DQEl4ekHL9ZTB0NqRmlNMbnvz04",
    authDomain: "clone-reactjs-42dcf.firebaseapp.com",
    projectId: "clone-reactjs-42dcf",
    storageBucket: "clone-reactjs-42dcf.appspot.com",
    messagingSenderId: "999707661268",
    appId: "1:999707661268:web:0cdd3dbeb65cd8f0737c41",
    measurementId: "G-ZR3X3E01VJ"
  })

  const db = firebaseApp.firestore();
  const auth = firebase.auth();

  export { db, auth };